type IProps = {
  title: string;
  subtitle?: string;
};

function FormHeader(props: IProps) {
  return (
    <div className="mb-6">
      <h2 className="text-2xl">{props.title}</h2>
      {props.subtitle && <h4 className="pt-6">{props.subtitle}</h4>}
    </div>
  );
}

export default FormHeader;
